import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgRightC({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.624 11L11.3 8.713A1 1 0 1112.7 7.287l4.066 3.998.001.002a1 1 0 01-.002 1.428l-4.065 3.998a1 1 0 01-1.402-1.426L13.624 13H8a1 1 0 110-2h5.624zM12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 100-16 8 8 0 000 16z"
        fill={color}
      />
    </svg>
  )
}

export default SvgRightC
